// Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';

// Utils
import { Accent, Text, Box } from '@nerdwallet/currency';

// Local components
import cityChange from '../../../lib/actions/cityChange';
import LocationAutoComplete from '../../location-autocomplete/location-autocomplete';

// Actions

// CSS
require('./city-header.less');

const CityHeader = (props) => {
  const { data, dispatch, browser } = props;
  const { manualInputs, inputs } = data;

  const header = 'This is what you can afford in ';

  return (
    <Box className="city-header" width={{ mobile: '100' }}>
      {browser.isMobile ? (
        <Text>{header}</Text>
      ) : (
        <Accent size="small">{header}</Accent>
      )}

      <LocationAutoComplete
        key="hac-location-autocomplete"
        data={manualInputs}
        placeholder={`${inputs.purchaseAddress.city}, ${inputs.purchaseAddress.state}`}
        onChange={(value) => dispatch(cityChange(value, 'purchaseAddress'))}
        trackingFormName="hac-results-panel"
      />
    </Box>
  );
};

CityHeader.displayName = 'CityHeader';

CityHeader.propTypes = {
  data: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  browser: PropTypes.object,
};

export default connect()(CityHeader);
